// import React from 'react';
import avatar1 from '../images/avatar1.png';
import qws from '../images/qws.png';
import amer from '../images/amer.png'
import god from '../images/god.png'
// import avatar2 from '../images/avatar2.png'
// import avatar3 from '../images/avatar3.png'
import { useNavigate } from 'react-router-dom';



const HeroSection = () => {

  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate('/check-eligibility');
  };

    return (
      <div>
  {/* Container */}
  <div className="flex flex-col items-center justify-center bg-white py-6 md:py-8 lg:py-10 mx-4 md:mx-8 lg:mx-12 overflow-hidden relative">
    
    {/* Header */}
    <h1 className="w-full max-w-[90%] font-inter font-bold 
                   text-[32px] md:text-[64px] lg:text-[120px] 
                   leading-[40px] md:leading-[80px] lg:leading-[130px] 
                   flex flex-wrap items-center justify-center 
                   text-center tracking-[-1px] md:tracking-[-1.5px] lg:tracking-[-2.24px] 
                   text-[#252525]">
      <span>ഫ്രീ</span> 
      <span className="ml-2">ഫാമിലി</span> 
      <div className="flex justify-center items-center">
        <img src={avatar1} alt="D" 
             className="object-contain 
                        h-[40px] w-[40px] 
                        md:h-[80px] md:w-[80px] 
                        lg:h-[100px] lg:w-[100px]" />
      </div> 
      <span className="ml-2">വിസ</span>
    </h1>
    
    <h1 className="w-full max-w-[90%] font-inter font-bold 
                   text-[32px] md:text-[64px] lg:text-[120px] 
                   leading-[40px] md:leading-[80px] lg:leading-[130px] 
                   flex flex-wrap items-center justify-center 
                   text-center tracking-[-1px] md:tracking-[-1.5px] lg:tracking-[-2.24px] 
                   text-[#252525] mt-4 md:mt-6 lg:mt-12">
      <div className="flex justify-center items-center mx-2">
        {/* Optionally include an image or element here */}
      </div> 
      <span className="ml-2">കാൽക്കുലേറ്റർ!</span>
      <div className="flex justify-center items-center mx-2">
        {/* Optionally include an image or element here */}
      </div>
    </h1>
  </div>
  
  {/* Paragraph */}
  <div className="mt-[10px] md:mt-[15px] lg:mt-[20px] text-center px-4">
    <p className="text-base md:text-xl lg:text-2xl 
                  mx-auto max-w-[90%] md:max-w-[600px] lg:max-w-[733px] 
                  leading-[1.5] text-center">
      എറ്റവും കുറഞ്ഞ ചിലവിൽ എങ്ങനെ ഫാമിലി വിസ എടുകാം. 
      ഫ്രീ ഫാമിലി വിസ കാൽക്കുലേറ്റർ ഉപയോഗിക്കൂ, വെറും 2 മിനിറ്റ് കൊണ്ട് അറിയാം.
    </p>
  </div>
  
  {/* Buttons */}
  <div className="flex flex-col md:flex-row 
                  space-y-4 md:space-y-0 md:space-x-4 
                  justify-center items-center 
                  mt-6 md:mt-8 lg:mt-10 
                  px-4 md:px-0">
    <button 
      onClick={handleNavigation}
      className="w-full md:w-[320px] lg:w-[348px] 
                 h-[50px] md:h-[70px] lg:h-[85px] 
                 bg-[#003DB7] text-white rounded-[50px] 
                 text-sm md:text-base lg:text-lg">
      Free Family Visa Calculator
    </button>
    <a href="https://wa.me/971525200725" className="w-full md:w-auto">
      <button 
        className="w-full md:w-[280px] lg:w-[293px] 
                   h-[50px] md:h-[70px] lg:h-[85px] 
                   bg-[#49C858] text-white rounded-[50px] 
                   text-sm md:text-base lg:text-lg">
        WhatsApp Now!
      </button>
    </a>
  </div>
  
  {/* Scrolling Image Section */}
  <div className="relative w-full overflow-hidden 
                  mt-[20px] md:mt-[25px] lg:mt-[30px] 
                  h-[50px] md:h-[70px] lg:h-[93.96px]">
    <div className="md:flex md:justify-center w-full">
      <div className="animate-scroll md:animate-none 
                      flex space-x-8 md:space-x-12 lg:space-x-16 
                      absolute md:static md:w-fit">
        <img src={qws} alt="img" 
             className="w-[80px] md:w-[100px] lg:w-[142.61px] 
                        h-[30px] md:h-[40px] lg:h-[52.85px]" />
        <img src={amer} alt="img" 
             className="w-[80px] md:w-[100px] lg:w-[142.61px] 
                        h-[30px] md:h-[40px] lg:h-[52.85px]" />
        <img src={god} alt="img" 
             className="w-[80px] md:w-[100px] lg:w-[142.61px] 
                        h-[30px] md:h-[40px] lg:h-[52.85px]" />
        
        <img src={qws} alt="img" 
             className="w-[80px] md:w-[100px] lg:w-[142.61px] 
                        h-[30px] md:h-[40px] lg:h-[52.85px]" />
        <img src={amer} alt="img" 
             className="w-[80px] md:w-[100px] lg:w-[142.61px] 
                        h-[30px] md:h-[40px] lg:h-[52.85px]" />
        <img src={god} alt="img" 
             className="w-[80px] md:w-[100px] lg:w-[142.61px] 
                        h-[30px] md:h-[40px] lg:h-[52.85px]" />
        
        {/* This group is visible only on mobile */}
        <div className="md:hidden flex space-x-8">
          <img src={qws} alt="img" className="w-[80px] h-[30px]" />
          <img src={amer} alt="img" className="w-[80px] h-[30px]" />
          <img src={god} alt="img" className="w-[80px] h-[30px]" />
        </div>
      </div>
    </div>
  </div>
</div>


   
    );
};

export default HeroSection;





